import { AppList, AppTitle } from 'components/atoms';
import { DailyScheduleEntryDTO } from 'types/schedule/dailySchedule';
import { useTheme } from 'styled-components';
import { DailyScheduleEntryItem } from './DailyScheduleEntryItem/DailyScheduleEntryItem';

type DailyScheduleEntriesListProps = {
    entries: DailyScheduleEntryDTO[];
};

export const DailyScheduleEntriesList = ({ entries }: DailyScheduleEntriesListProps) => {
    const theme = useTheme();

    if (!entries || entries.length === 0) {
        return null;
    }

    return (
        <>
            <AppTitle level={4} textAlign="center" margin={0} marginTop={32} marginBottom={16}>
                Historia planów dziennych
            </AppTitle>
            <AppList
                dataSource={entries}
                marginTop={theme.sizes.marginNormal}
                renderItem={(entry: DailyScheduleEntryDTO) => (
                    <DailyScheduleEntryItem entry={entry} />
                )}
            />
        </>
    );
};
